import { useState } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { useAuth } from "../AuthContext";
import { fmtError } from "../api";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      await login(email, password);
      nav(loc.state?.from || "/", { replace: true });
    } catch (e) {
      setErr(fmtError(e.response?.data?.detail) || e.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="login-screen" data-testid="login-screen">
      <div className="login-bg" />
      <form className="login-box" onSubmit={submit}>
        <img
          src={`${process.env.PUBLIC_URL || ""}/admatik-logo.png`}
          alt="Admatik"
          style={{ height: 48, width: "auto", display: "block", marginBottom: 16 }}
          data-testid="login-logo"
        />
        <div className="login-logo">Admatik <span>Rmax</span></div>
        <div className="login-tagline">Multi-Platform Command Centre</div>

        {err && <div className="login-error" data-testid="login-error">{err}</div>}

        <div className="form-group">
          <div className="login-label">Email</div>
          <input
            className="login-input"
            type="email"
            placeholder="your@email.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            data-testid="login-email"
          />
        </div>
        <div className="form-group">
          <div className="login-label">Password</div>
          <input
            className="login-input"
            type="password"
            placeholder="••••••••"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            data-testid="login-password"
          />
        </div>

        <button className="login-btn" type="submit" disabled={busy} data-testid="login-submit">
          {busy ? "Entering..." : "🎂 Happy Birthday Abhi !"}
        </button>

        <Link className="login-link" to="/forgot-password" data-testid="forgot-link">
          Forgot password?
        </Link>

        <div className="login-note">🚀 Launch date on 2nd Aug 2026</div>
      </form>
    </div>
  );
}
